import { ChangeEvent, useEffect, useState, useMemo } from 'react';
import {
  InputAdornment,
  Skeleton,
  Table,
  TableBody,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { useGetExternalServiceCodesGrouped } from 'api/externalServiceCode';
import { StyledTextField } from 'components/Inputs';
import { StyledTableCell, StyledTableHeadCell } from 'components/Table';
import { IoIosResize } from 'react-icons/io';
import { IoSearch } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import { reactPaths } from 'root/pathnames';
import { mainColumnHeaders, searchPlaceholder } from '../MappingModule.consts';
import * as S from './MappingServiceDetails.css';

export const ServiceSideTable = ({
  activeServiceId,
}: {
  activeServiceId: string;
}) => {
  const navigate = useNavigate();

  const {
    data: groupedData,
    loading,
    getExternalServiceCodesGrouped,
  } = useGetExternalServiceCodesGrouped();

  useEffect(() => {
    getExternalServiceCodesGrouped({ pageNumber: 1, resultSize: 1000 });
  }, [getExternalServiceCodesGrouped]);

  const allServices = useMemo(
    () =>
      (groupedData ?? []).map((item) => ({
        id: String(item.activityId),
        serviceName: item.activityCode,
      })),
    [groupedData],
  );

  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const filtered = useMemo(() => {
    if (!search.trim()) return allServices;
    const q = search.toLowerCase();
    return allServices.filter((service) =>
      service.serviceName.toLowerCase().includes(q),
    );
  }, [allServices, search]);

  const handleClick = (id: string) => {
    navigate(`/mapping/${id}`);
  };

  return (
    <S.SideTableContainer>
      <S.ToolbarContainer>
        <S.ResizeButton
          size='small'
          onClick={() => navigate(reactPaths.mappingModule)}
        >
          <IoIosResize size='25' />
        </S.ResizeButton>
        {/* <StyledTextField
          placeholder={searchPlaceholder}
          type='text'
          size='small'
          padding='dense'
          width={224}
          value={search}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            setSearch(event.target.value)
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IoSearch />
              </InputAdornment>
            ),
          }}
        /> */}
      </S.ToolbarContainer>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableHeadCell height='condensed'>
              {mainColumnHeaders.internalActivity}
            </StyledTableHeadCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading
            ? Array.from(new Array(10)).map((_, index) => (
                <TableRow key={index}>
                  <StyledTableCell height='condensed' padding='checkbox'>
                    <Skeleton variant='text' width={100} />
                  </StyledTableCell>
                </TableRow>
              ))
            : filtered.slice(page * 10, page * 10 + 10).map((service) => (
                <S.ServiceRow
                  key={service.id}
                  hover
                  $active={service.id === activeServiceId}
                  onClick={() => handleClick(service.id)}
                >
                  <StyledTableCell height='condensed' padding='checkbox'>
                    {service.serviceName}
                  </StyledTableCell>
                </S.ServiceRow>
              ))}
        </TableBody>
      </Table>
      {filtered.length > 10 && (
        <TablePagination
          component='div'
          count={filtered.length}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
          page={page}
          onPageChange={(_, pag) => setPage(pag)}
          labelDisplayedRows={({ from, to, count }) =>
            `${from} - ${to} z ${count}`
          }
        />
      )}
    </S.SideTableContainer>
  );
};
